import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
    components: {
        VueCropper,
    },

    data() {
        return {
            imageCroppedSrc: null,

            imageSrc: null,

            fileInfo: null,
        }
    },

    computed: {
        isImage() {
            if (!this.fileInfo) {
                return false
            }

            return this.fileInfo.type.includes('image/')
        },
    },

    methods: {
        cropImage() {
            this.imageCroppedSrc = this.$refs.cropper.getCroppedCanvas().toDataURL();
        },

        onSelectImage() {
            this.$refs.fileInput.click()
        },

        setImage({target}) {
            const file = target.files[0]

            this.fileInfo = file

            if (typeof FileReader === 'function') {
                const reader = new FileReader()

                reader.onload = (event) => {
                    this.imageSrc = event.target.result;

                    // Rebuild cropperjs with the updated source
                    if (this.$refs.cropper) {
                        this.$refs.cropper.replace(event.target.result)
                    }
                }

                reader.readAsDataURL(file)
            } else {
                this.errors.push(['FileReader API not supported by this browser. Use an evergreen browser.'])
            }
        },

        // async updateImage(data) {
        //     // return new uploaded image url
        // },

        async uploadImage(resource) {
            await this.$refs.cropper.getCroppedCanvas().toBlob(async blob => {
                let formData = new FormData()

                formData.append('image', blob)

                try {
                    this.imageCroppedSrc = await this.updateImage({resource: resource, formData: formData})
                } catch (error) {
                    let message = null

                    if (error.response.data) {
                        message = error.response.data.errors
                    } else {
                        message = {logo: ['Failed to upload logo.']}
                    }

                    this.errors = message
                }
            })
        },
    }
}